import { DealOption } from './deal-types'

export function getDealOptionByKey(options: DealOption[], optionKey: string) {
    return options.find(option => {
        if (option.__typename === 'BooleanDealOption') {
            return option.key === optionKey
        } else if (option.__typename === 'SelectableDealOption') {
            return option.name === optionKey
        }
    })
}

export function getDealOptionKey(option: DealOption) {
    return option.__typename === 'BooleanDealOption' ? option.key : option.name
}

export function getDealOptionValue(option: DealOption) {
    return option.__typename === 'BooleanDealOption' ? option.value : option.selectedValue.label
}
